import { render, staticRenderFns } from "./income1.vue?vue&type=template&id=0c4fb9fe&scoped=true"
import script from "./income1.vue?vue&type=script&lang=js"
export * from "./income1.vue?vue&type=script&lang=js"
import style0 from "./income1.vue?vue&type=style&index=0&id=0c4fb9fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4fb9fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4fb9fe')) {
      api.createRecord('0c4fb9fe', component.options)
    } else {
      api.reload('0c4fb9fe', component.options)
    }
    module.hot.accept("./income1.vue?vue&type=template&id=0c4fb9fe&scoped=true", function () {
      api.rerender('0c4fb9fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/income1.vue"
export default component.exports